import Prefixs from './Prefixs'

export default Prefixs